var iframeResize = require('./iframeResizer')

exports.iframeResize = iframeResize
exports.iframeResizer = iframeResize // Backwards compatability
exports.iframeResizerContentWindow = require('./iframeResizer.contentWindow')



//////////////////
// WEBPACK FOOTER
// ./node_modules/iframe-resizer/js/index.js
// module id = 1336
// module chunks = 1